import React from 'react';
import { Link } from 'react-router-dom';
import { FiLock, FiArrowRight, FiZap } from 'react-icons/fi';

export default function PlanUpgradeCard({
  title,
  description,
  bullets = [],
  planLabel = 'Profesional',
  modoOscuro = false,
  box = '',
  textPri = '',
  textMuted = '',
  compact = false,
}) {
  const bulletIcon = modoOscuro ? 'text-[#5CA3FF]' : 'text-[#1F80FF]';

  if (compact) {
    return (
      <div className={`rounded-2xl border overflow-hidden ${
        modoOscuro ? 'border-amber-800/40 bg-gradient-to-r from-amber-950/40 to-gray-900' : 'border-amber-200 bg-gradient-to-r from-amber-50 to-white'
      }`}>
        <div className="px-4 py-3.5 flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-start gap-3 min-w-0">
            <span className={`p-2 rounded-xl shrink-0 ${modoOscuro ? 'bg-amber-900/50 text-amber-200' : 'bg-amber-100 text-amber-800'}`}>
              <FiLock className="w-4 h-4" />
            </span>
            <p className={`text-sm leading-snug ${modoOscuro ? 'text-amber-100' : 'text-amber-950'}`}>
              {description}
            </p>
          </div>
          <Link
            to="/planes"
            className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-xl text-xs font-semibold bg-[#1F80FF] text-white hover:bg-[#004AAD] shrink-0 shadow-sm"
          >
            Plan {planLabel}
            <FiArrowRight className="w-3.5 h-3.5" />
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className={`rounded-2xl border overflow-hidden ${box || (modoOscuro ? 'bg-gray-900 border-gray-700' : 'bg-white border-gray-200')}`}>
      <div className="px-4 sm:px-8 py-8 sm:py-10 text-center">
        <div className={`inline-flex p-3.5 rounded-2xl mb-4 ${modoOscuro ? 'bg-gray-800 text-gray-300' : 'bg-gray-100 text-gray-600'}`}>
          <FiLock className="w-6 h-6" />
        </div>
        <h3 className={`text-base sm:text-lg font-semibold mb-2 ${textPri || (modoOscuro ? 'text-white' : 'text-gray-900')}`}>{title}</h3>
        <p className={`text-xs sm:text-sm mb-5 max-w-md mx-auto leading-relaxed ${textMuted || 'text-gray-500'}`}>{description}</p>
        {bullets.length > 0 && (
          <ul className={`text-left text-xs sm:text-sm space-y-2.5 max-w-sm mx-auto mb-6 ${textMuted || 'text-gray-500'}`}>
            {bullets.map((item) => (
              <li key={item} className="flex items-start gap-2.5">
                <FiZap className={`w-4 h-4 shrink-0 mt-0.5 ${bulletIcon}`} />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        )}
        <Link
          to="/planes"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-semibold bg-[#1F80FF] text-white hover:bg-[#004AAD] shadow-sm"
        >
          Ver plan {planLabel}
          <FiArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}
